
import React, { useState } from "react";
import styles from "./StepCircle.module.css";
import {
  StepCircleProps
} from "./StepCircle.types"

const StepCircle: React.FC<StepCircleProps> = ({ stepNumber, isActive, onClick, disabled }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      className={`
        ${styles.step} 
        ${isActive ? styles.stepActive : styles.stepInactive} 
        ${isHovered && !isActive ? styles.stepInactiveHover : ""}
      `}
      onClick={disabled ? undefined : () => onClick(stepNumber)}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {stepNumber}
    </div>
  );
};

export default StepCircle;